export const isIE = () => {
  if (navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode === true) {
    return true;
  }
  return false;
};

// 국가전화번호 코드값 공유하는 국가 merge
export const mergeNationCode = nationCodeList => {
  const mergeNationCodeList = [];
  for (let i = 0; i < nationCodeList.length; i++) {
    let isFind = false;
    for (let j = 0; j < mergeNationCodeList.length; j++) {
      if (nationCodeList[i].rsrcCdVal === mergeNationCodeList[j].rsrcCdVal) {
        isFind = true;
        const temp = {
          ...mergeNationCodeList[j],
          rsrcKeyVal: `${mergeNationCodeList[j].rsrcKeyVal}|${nationCodeList[i].rsrcKeyVal}`,
        };
        mergeNationCodeList.splice(j, 1, temp);
        break;
      }
    }
    if (!isFind) {
      mergeNationCodeList.push(nationCodeList[i]);
    }
  }
  return mergeNationCodeList;
};

export const getHostDomain = () => {
  const BRITYWORKS_EMAIL_DOMAIN = {
    DEV: '@dev.brityworks.com',
    STAGE: '@stage.brityworks.com',
    PROD: '@brityworks.com',
  };

  if (window.location.hostname.indexOf('dev.') > -1 || window.location.hostname.indexOf('localhost.') > -1) {
    return BRITYWORKS_EMAIL_DOMAIN.DEV;
  }
  if (window.location.hostname.indexOf('stage.') > -1) {
    return BRITYWORKS_EMAIL_DOMAIN.STAGE;
  }
  return BRITYWORKS_EMAIL_DOMAIN.PROD;
};

export const checkKoreaNationCode = nationCode => {
  return nationCode === '+82';
};

/**
 * USER_ID와 외부메일 도메인이 같은지 확인
 * @returns {boolean}
 */
export const checkHasSameDomain = (userIdDomain, extrEmailDomain) => {
  return userIdDomain?.split('@')[1]?.trim() === extrEmailDomain?.split('@')[1]?.trim();
};
